import Splide from '@splidejs/splide'
import '@splidejs/splide/css/core';

export default function Sliders() {
	// --- Banner Slider ---
	const bannerElements = document.querySelector('.js-banner-slider')
	bannerElements && new Splide('.js-banner-slider', {
		type: 'slide',
		arrows: false,
		pagination: true,
		keyboard: false,
		drag: true,
		rewind: true,
		autoplay: false,
		speed: 1000,
		interval: 5000,
		pauseOnHover: false,
		snap: true,
		autoHeight: true,
		classes: {
			pagination: 'splide__pagination dots-parent justify-center absolute bottom-10 left-[50%] translate-x-[-50%]',
			page: 'splide__pagination__page dots dots-white'
		},
	}).mount()

	const inspiration = document.querySelectorAll('.js-inspiration-slider')
	for (let i = 0; i < inspiration.length; i++) {
		new Splide(inspiration[i], {
			type: 'loop',
			perPage: 1,
			arrows: false,
			pagination: true,
			keyboard: false,
			drag: true,
			rewind: true,
			autoplay: false,
			speed: 1000,
			interval: 5000,
			pauseOnHover: false,
			snap: true,
			autoHeight: true,
			gap: 40,
			mediaQuery: 'min',
			breakpoints: {
				450: {
					perPage: 2,
				},
				1023: {
					perPage: 3,
				},
			},
			classes: {
				pagination: 'splide__pagination dots-parent justify-center absolute -bottom-10',
				page: 'splide__pagination__page dots dots-black'
			},
		}).mount()
	}

	// --- Testimonial Sliders ---
	const testimonials = document.querySelectorAll('.js-testimonial-slider')
	for (let i = 0; i < testimonials.length; i++) {
		new Splide(testimonials[i], {
			type: 'slide',
			perPage: 1,
			perMove: 1,
			gap: 40,
			pagination: true,
			arrows: false,
			mediaQuery: 'min',
			autoplay: false,
			breakpoints: {
				767: {
					perPage: 2,
				},
				1023: {
					perPage: 3,
				},
			},
			classes: {
				pagination: 'splide__pagination dots-parent justify-center absolute -bottom-10 left-0',
				page: 'splide__pagination__page dots dots-black'
			},
		}).mount()
	}

	let product = document.querySelector('.js-product-display')
	let thumbnails = document.querySelector('.js-product-display-thumbs')

	if (product && thumbnails) {
		let main = new Splide( '.js-product-display', {
			type       : 'fade',
			pagination : false,
			arrows     : false,
			autoHeight: true,
		} );
		let thumbs = new Splide( '.js-product-display-thumbs', {
			rewind          : true,
			isNavigation    : true,
			gap             : 10,
			perPage		 : 4,
			arrows		  : false,
			focus           : 'center',
			pagination      : false,
			mediaQuery: 'min',
			breakpoints : {
				640: {
					perPage: 6,
				},
			},
		} );

		main.sync( thumbs );
		main.mount();
		thumbs.mount();

	}


}
